import { t } from '@lingui/core/macro';
import { Alert, AvatarWithLabel, Box, DialogContent, Typography, pxToRem } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { AdvancedApprovalCheckPreview } from '../../../AdvancedApprovalCheckPreview';
import { zDocumentApprovalResultSchema } from '../../Approvers/RequestVoluntaryAdvanced/ApprovalCheckProvider/useStreamApprovalCheck/schemas';
export function Content(props) {
    const { plaiResponse, additionalContext, workflowUsed } = props;
    const { success, data } = zDocumentApprovalResultSchema.safeParse(JSON.parse(plaiResponse));
    const promptLabel = t({
        message: 'Workflow used',
        comment: 'Approval requirement check dialog - Workflow used label',
    });
    const additionalContextLabel = t({
        message: 'Workflow used with additional context',
        comment: 'Approval requirement check dialog - Workflow used with additional context label',
    });
    const subtitle = additionalContext ? additionalContextLabel : promptLabel;
    if (!success) {
        return (<DialogContent>
        <Alert appearance="danger" message={t({ message: 'Invalid message format', comment: 'Invalid message format' })}/>
      </DialogContent>);
    }
    const { summary, isApprovalRequired, approvers } = data;
    return (<DialogContent>
      <Box flexDirection="column" gap="md" mb="xl">
        <AvatarWithLabel solid size="sm" appearance="info" title={workflowUsed.name} subtitle={subtitle}>
          <Falcon icon="bookmark"/>
        </AvatarWithLabel>
        {additionalContext && (<Typography $fontSize="small" $appearance="300">
            {additionalContext}
          </Typography>)}
      </Box>
      <Box mb="xl" alignItems="center" justifyContent="center" width={pxToRem(24)} height={pxToRem(24)}>
        <Falcon $color="gray.400" icon="arrow-down"/>
      </Box>
      <AdvancedApprovalCheckPreview isApprovalRequired={isApprovalRequired} summary={summary} approvers={approvers}/>
    </DialogContent>);
}
